import { useContext, useEffect, useState } from "react";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";
import { useParams } from "react-router-dom";
const PayTRIframe = ({ iframeToken }) => {
  const { slug } = useParams();
  const {
    backendURL,
    setUserNote,
    setPending,
    setIsErr,
    user,
    setShowAlert,
    navigate,
    setAlertMessage,
  } = useContext(PitchContext);
  const [timeLeft, setTimeLeft] = useState(300);
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.paytr.com/js/iframeResizer.min.js";
    script.onload = () => {
      window.iFrameResize({}, "#paytriframe");
    };
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          executeAfterFiveMinutes();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    return () => {
      const storedIsPaid = localStorage.getItem("isPaid");
      if (storedIsPaid !== "true") {
        setUserNote("");
        executeAfterFiveMinutes();
      }
    };
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  const executeAfterFiveMinutes = () => {
    setPending(true);
    axios
      .post(backendURL + "booking/remove", {
        userID: user._id,
        bookingID: localStorage.getItem("bookingID"),
        slug,
      })
      .then((_) => {
        setPending(false);
        localStorage.removeItem("bookingID");
        setIsErr(true);
        setShowAlert(true);
        setAlertMessage(
          "Ödemenizi tamamlamadığınız için rezervasyon işleminiz iptal edilmiştir."
        );
        navigate("/");
      })
      .catch((err) => {
        setPending(false);
        localStorage.removeItem("bookingID");
        console.log(err);
      });
  };

  return (
    <div>
      <div className="">
        <p>{formatTime(timeLeft)}</p>
      </div>
      <div className="">
        <iframe
          src={`https://www.paytr.com/odeme/guvenli/${iframeToken}`}
          id="paytriframe"
          frameBorder="0"
          scrolling="no"
          style={{ width: "100%", minHeight: "600px" }}
        ></iframe>
      </div>
    </div>
  );
};

export default PayTRIframe;
